(() => {
  if (window.__freeSampleInjectInit) return;
  window.__freeSampleInjectInit = true;

  const FALLBACK_MS = 6000;
  const SIZE_SELECTORS = [
    '.variant-input-wrapper[data-option-slug="size"]',
    '.variant-input-wrapper[data-option-slug*="seater"]',
    '.product-form__input--dropdown.variant-input-wrapper'
  ];

  let scheduled = false;

  const resolvePosition = (anchor, preferredPosition) => {
    if (preferredPosition) return preferredPosition;
    if (anchor.matches?.('.pl-swatches__group--colors')) return 'after';
    return 'after';
  };

  const queryInScopes = (section, selector) => {
    if (section) {
      const inSection = section.querySelector(selector);
      if (inSection) return inSection;
    }

    return document.querySelector(selector);
  };

  const findInScopes = (section, finder) => {
    if (section) {
      const inSection = finder(section);
      if (inSection) return inSection;
    }

    return finder(document);
  };

  const findInsertPoint = (section, selector, preferredPosition) => {
    if (selector) {
      const anchor = queryInScopes(section, selector);
      if (anchor) {
        return { node: anchor, position: resolvePosition(anchor, preferredPosition) };
      }
    }

    const colorGroup = findInScopes(section, (scope) => scope.querySelector('.pl-swatches__group--colors'));
    if (colorGroup) {
      return { node: colorGroup, position: 'after' };
    }

    for (const sizeSelector of SIZE_SELECTORS) {
      const sizeNode = findInScopes(section, (scope) => scope.querySelector(sizeSelector));
      if (sizeNode) {
        return { node: sizeNode, position: 'before' };
      }
    }

    const variantPicker = findInScopes(section, (scope) => scope.querySelector('variant-picker'));
    if (variantPicker) {
      return { node: variantPicker, position: 'after' };
    }

    return null;
  };

  const isCorrectlyPlaced = (bar, insertPoint) => {
    const { node, position } = insertPoint;

    if (position === 'after') {
      return bar.previousElementSibling === node;
    }

    if (position === 'before') {
      return bar.nextElementSibling === node;
    }

    return node.contains(bar);
  };

  const placeContent = (content, insertPoint) => {
    const { node, position } = insertPoint;

    if (position === 'after') {
      node.insertAdjacentElement('afterend', content);
      return;
    }

    if (position === 'before') {
      node.insertAdjacentElement('beforebegin', content);
      return;
    }

    node.appendChild(content);
  };

  const getTemplateBar = (mount) => {
    const template = mount.querySelector('template[data-free-sample-template]');
    if (template?.content.firstElementChild) {
      return template.content.firstElementChild;
    }

    return mount.querySelector('.free-sample-bar, .swatchbox_wrapper');
  };

  const createInjectedBar = (mount) => {
    const templateBar = getTemplateBar(mount);
    if (!templateBar) return null;

    const bar = templateBar.cloneNode(true);
    bar.dataset.freeSampleInjected = mount.dataset.mountId;
    bar.classList.add('swatchbox_wrapper--pl-swatches', 'swatchbox_wrapper--compact');
    return bar;
  };

  const removeInjectedBars = (mountId) => {
    document.querySelectorAll(`[data-free-sample-injected="${mountId}"]`).forEach((bar) => {
      bar.remove();
    });
  };

  const ensureInjected = (mount) => {
    const mountId = mount.dataset.mountId;
    if (!mountId) return false;

    const selector = mount.dataset.injectSelector;
    const preferredPosition = mount.dataset.injectPosition;
    const section = mount.closest('[id^="shopify-section-"]');
    const insertPoint = findInsertPoint(section, selector, preferredPosition);

    if (!insertPoint) return false;

    const existing = document.querySelector(`[data-free-sample-injected="${mountId}"]`);
    if (existing?.isConnected && isCorrectlyPlaced(existing, insertPoint)) {
      return true;
    }

    removeInjectedBars(mountId);

    const bar = createInjectedBar(mount);
    if (!bar) return false;

    placeContent(bar, insertPoint);
    return true;
  };

  const showFallback = (mount) => {
    if (mount.dataset.fallbackShown === 'true') return;
    mount.dataset.fallbackShown = 'true';

    const mountId = mount.dataset.mountId;
    removeInjectedBars(mountId);

    const bar = createInjectedBar(mount);
    if (!bar) return;

    bar.classList.remove('swatchbox_wrapper--pl-swatches');
    bar.classList.add('swatchbox_wrapper--variant-picker');
    mount.hidden = false;
    mount.classList.remove('hidden');
    mount.appendChild(bar);
  };

  const scheduleFallback = (mount) => {
    if (mount.dataset.fallbackScheduled === 'true') return;
    mount.dataset.fallbackScheduled = 'true';

    window.setTimeout(() => {
      if (ensureInjected(mount)) return;
      showFallback(mount);
    }, FALLBACK_MS);
  };

  const processMounts = () => {
    document.querySelectorAll('[data-free-sample-mount]').forEach((mount) => {
      if (!mount.dataset.mountId) return;

      if (!ensureInjected(mount)) {
        scheduleFallback(mount);
      }
    });
  };

  const scheduleProcess = () => {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      processMounts();
    });
  };

  const init = () => {
    processMounts();

    const observer = new MutationObserver(scheduleProcess);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('variant:change', scheduleProcess);

    if (window.theme?.pubsub?.PUB_SUB_EVENTS?.variantChange) {
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, scheduleProcess);
    }

    document.addEventListener('product-info:loaded', scheduleProcess);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
